/**
 * Servicio para obtener datos relacionados con el cotizador
 */

import { getRegions } from "@a365/api";

/**
 * Obtiene la lista de regiones disponibles para el cotizador desde la API
 * @returns {Promise<Array>} Lista de regiones con formato { id, name }
 */
export const getQuoteRegions = async () => {
  try {
    const apiRegions = await getRegions();
    const filteredRegions = (apiRegions?.data || []).filter(region => region.id !== 18);
    return filteredRegions;
  } catch (error) {
    console.error("Error al obtener regiones desde la API:", error);
    return [];
  }
};

/**
 * Obtiene una región específica por ID
 * @param {number} regionId - ID de la región
 * @returns {Object|null} Región encontrada o null
 */
export const getRegionById = async (regionId) => {
  try {
    const regions = await getQuoteRegions();
    return regions.find(region => region.id === regionId) || null;
  } catch (error) {
    console.error("Error al obtener región por ID:", error);
    return null;
  }
};

/**
 * Obtiene una región específica por nombre
 * @param {string} name - Nombre de la región
 * @returns {Object|null} Región encontrada o null
 */
export const getRegionByName = async (name) => {
  try {
    const regions = await getQuoteRegions();
    return regions.find(region => region.name === name) || null;
  } catch (error) {
    console.error("Error al obtener región por nombre:", error);
    return null;
  }
};